var map = {
	"./Advanced Analytics.png": 369,
	"./Bringing-Value-with-AI--.png": 370,
	"./Data & AI Ethics.png": 371,
	"./Data Driven Business Analytics.png": 372,
	"./Data Governance.png": 373,
	"./Data Migration.png": 374,
	"./Data Mining.png": 375,
	"./Data Modeling Languages.png": 376,
	"./Data Monetization.png": 377,
	"./Data Privacy.png": 378,
	"./Data Strategies.png": 379,
	"./Identifying Patterns in Data.png": 380,
	"./Internet of Things (IoT) and edge computing.png": 381,
	"./Predictive Analytics.png": 382,
	"./Real-Time Analytics.png": 383,
	"./Real-Time Data Visualization.png": 384,
	"./Scaling with Data.png": 385,
	"./chatgpt-logo-02AFA704B5-seeklogo.com.png": 386,
	"./data-management.png": 387,
	"./data-warehouse.png": 388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 368;